<!--header image-->
<div [hidden]="!headerImageVisible">
    <app-header></app-header>
    <br />
</div>

<!-- main content -->
<div class="vw-container">
    <div class="vw-row" style="background-color:transparent;">
        <div>
            <app-vwsa-text text="{{headerText}}" appearance="headline350" weight="bold"></app-vwsa-text>
            <app-vwsa-text text="{{subHeaderText}}" appearance="headline350"></app-vwsa-text>
            <div style="margin-left:-15px;">
                <p-tabView [(activeIndex)]="activeTabIndex">
                    <p-tabPanel header="01. Your Details" [disabled]="activeTabIndex!=0">
                    </p-tabPanel>
                    <p-tabPanel header="02. Select Your Plan" [disabled]="activeTabIndex!=1">
                    </p-tabPanel>
                    <p-tabPanel header="03. Purchase" [disabled]="activeTabIndex!=2" *ngIf="!justBrowsing">
                    </p-tabPanel>
                </p-tabView>
                <div style="margin-top:-20px;margin-left:15px;margin-right:15px;">
                    <router-outlet></router-outlet>
                </div>
                <!--modal for 'contact us'-->
                <jw-modal id="contact-us" headerText="Contact Us">
                    <app-contact-us #contactUs></app-contact-us>
                </jw-modal>
                <!--dialog modal-->
                <app-dialog header="{{dialogHeader}}" message="{{dialogMessage}}" [(visible)]="dialogVisible" (closeDialog)="onCloseDialog()">
                </app-dialog>
                <!--loading spinner-->
                <div [hidden]="!loaderVisible" style="position:fixed;top:40vh;left:45%;z-index:12000;">
                    <app-vwsa-spinner></app-vwsa-spinner>
                </div>
                <div [hidden]="!loaderVisible" style="background-color:black;opacity:0.25;position:fixed;z-index:1000;top:0;bottom:0;left:0;right:0;">
                </div>
                <!--contact us button-->
                <div class="contact-us-btn">
                    <app-vwsa-button text="Contact Us" (click)="onShowContactUsDialog()">
                    </app-vwsa-button>
                </div>
            </div>
        </div>
    </div>
</div>

<!--modal for confirming app update-->
<p-dialog header="Update Available" [(visible)]="displayUpdateNotice" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p>
        A new version is available, do you want to update?
    </p>
    <ng-template pTemplate="footer">
        <app-vwsa-button (click)="onConfirmUpdate(false)" text="No"></app-vwsa-button>
        <app-vwsa-button (click)="onConfirmUpdate(true)" text="Yes"></app-vwsa-button>
    </ng-template>
</p-dialog>